let prevScrollpos = 0;
let up = false;

function repeatOften() {
    const navbar = document.getElementById('navbar');
    const currentScrollPos = window.scrollY;

    if (!navbar) {
        return;
    }

    if (currentScrollPos > 300) {
        navbar.classList.add('navbar--sticky');
    }
    else if (currentScrollPos == 0) {
        navbar.classList.remove('navbar--sticky');
    }


    requestAnimationFrame(repeatOften);
};


requestAnimationFrame(repeatOften);
